import {
  MainContainer,
  MainContainerFullWidth
} from "../../styles/basicStyles";
import { ProcessPageType } from "../../models/process";
import { useTranslation } from "next-i18next";
import { FC} from "react";
import { colors } from "../../styles/colors";
import ContactBanner from "../../components/views/contactBanner";
import HowWeCanHelp from "./components/howWeCanHelp";
import Technologies from "./components/technologies";
import OurProcess from "./components/ourProcess";
import Graph from "./components/graph";
import Metatags from "../../components/metatags";
import GlobalBanner from "../../components/views/globalBanner";

interface Props {
  data: ProcessPageType;
}

const Process: FC<Props> = ({ data }) => {
  const { i18n: { language } } = useTranslation();
  
  return (
    <>
      <Metatags
        title={data.meta_title && data.meta_title[language]}
        description={data.meta_description && data.meta_description[language]}
        keywords={data.meta_keywords && data.meta_keywords[language]}
        image={data.meta_image?.url}
      />
      <GlobalBanner
        page={data?.category && data?.category[language].toUpperCase()}
        title={data?.title && data?.title[language]}
        description={data?.description && data?.description[language]}
        bgColor={colors.chineseBlack}
        origin="process"
      />
      <MainContainer>
        <HowWeCanHelp />
        <Graph />
      </MainContainer>
      {data?.blocks && data?.blocks.length > 0 && (
        <OurProcess blocks={data?.blocks} />
      )}
      {data?.technologies && data?.technologies.length > 0 && (
        <Technologies technologies={data?.technologies} />
      )}
      <MainContainerFullWidth>
        <ContactBanner />
      </MainContainerFullWidth>
    </>
  );
};

export default Process;
